var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2D2B32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.333 16.986c.337.329.795.514 1.272.514h10.79a1.82 1.82 0 0 0 1.271-.514M10.001 2.5v9.952m0 0 4.11-3.803m-4.11 3.803L5.89 8.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload02);
export default __webpack_public_path__ + "static/media/download-02.2ce31c2d00fb742cd8e6d39b41b722d2.svg";
export { ForwardRef as ReactComponent };